export default __webpack_public_path__ + "static/media/contact.6363348b.svg";